var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",style:({ backgroundColor: _vm.bgc })},[_c('img',{attrs:{"src":require("@/assets/img/loading-red.svg")}}),_c('div',{staticClass:"text"},[_vm._v("loading..")])])}
var staticRenderFns = []

export { render, staticRenderFns }